import { render } from "./Schedule.vue?vue&type=template&id=0f31aa2e"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
script.render = render

export default script